import DropDownMenuLabelItem from './DropDownMenuLabelItem';
export default DropDownMenuLabelItem;
